import React from 'react';
import { is, has } from '../../services/index';
import { Text, TextLevels } from '../text';
import { Columns, ColumnsItem } from '../columns';
import { getAlertClassName } from '../../objects';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../context';
/**
 * Progress component
 * @param children {ReactNode} Use Children it only if stacked progress
 * @param percent {number} Progress percent
 * @param maxPercent {number} Default max percent is 100
 * @param alert {AlertState} Progress alert variant (SUCCESS|INFO|WARNING|ERROR)
 * @param small {boolean} Small progress
 * @param stacked {boolean} Stacked progress
 * @param uniqueLegend {string} Unique legend
 * @param firstExtremLegend {string} First extremity legend, only with secondExtremLegend property
 * @param secondExtremLegend {string} Second extremity legend, only with firstExtremLegend property
 * -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS classes
 */
const Progress = ({ children, className, percent, maxPercent = 100, alert, small, stacked, uniqueLegend, firstExtremLegend, secondExtremLegend, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('progress', alert && is(getAlertClassName(alert)), !alert && is('primary'), small && is('small'), className));
    const stackedClasses = hashClass(styled, clsx('progress', stacked && is('stacked'), className));
    if (children && stacked) {
        return (React.createElement("div", { className: stackedClasses, ...others }, children));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("progress", { className: classes, value: percent, max: maxPercent, ...others }, percent),
        uniqueLegend && (React.createElement(Text, { className: has('text-centered'), level: TextLevels.TWO }, uniqueLegend)),
        firstExtremLegend && secondExtremLegend && (React.createElement(Columns, { mobile: true, marginSize: 3 },
            React.createElement(ColumnsItem, null,
                React.createElement(Text, { level: TextLevels.TWO }, firstExtremLegend)),
            React.createElement(ColumnsItem, { narrow: true },
                React.createElement(Text, { level: TextLevels.TWO }, secondExtremLegend))))));
};
export default Progress;
//# sourceMappingURL=Progress.js.map